import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payments-adapter',
  templateUrl: './payments-adapter.component.html',
  styleUrls: ['./payments-adapter.component.scss']
})
export class PaymentsAdapterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
